<common-ui-components-page-layout
  [title]="'راهنمای فروشگاه‌ها'"
  [closeButton]="true"
  [showBorder]="false"
>
  <div class="px-plus">
    <span class="b-3 text-onback-high"
      >با وام بانکی و یا اعتبار دیجی‌پی‌ می‌توانید از فروشگاه‌های مختلف، کالا یا خدمات موردنظر خود را به صورت حضوری یا آنلاین خریداری کنید.
      نحوه خرید و پرداخت در فروشگاه‌ها در این بخش شرح داده شده است.</span
    >
    <div class="d-flex flex-column mt-mega">
      <ngx-accordion [configs]="accordionConfigs()"></ngx-accordion>
    </div>
  </div>
</common-ui-components-page-layout>
